import React from 'react';

const JsonTable = ({ data }) => {
  const renderValue = (value) => {
    if (value === null) return '-';
    if (value === undefined) return '-';
    if (value === '') return '-';
    // Highlight checkmark (✓) when it appears as a direct value
    if (value === '✓') return <span className="status-check">✓</span>;
    if (typeof value === 'boolean') return value.toString();
    if (typeof value === 'object') {
      // Handle objects with value and status properties
      if ('value' in value && 'status' in value) {
        return (
          <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
            <div style={{ width: '60%', paddingRight: '12px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {typeof value.value === 'object' ? JSON.stringify(value.value) : (value.value || '-')}
            </div>
            <div style={{ width: '10%', paddingRight: '12px', textAlign: 'center' }}>
              {value.status === '✓' ? (
                <span className="status-check">✓</span>
              ) : value.status || '-'}
            </div>
            <div style={{ width: '30%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {value.notes || '-'}
            </div>
          </div>
        );
      }
      // Handle arrays
      if (Array.isArray(value)) {
        return (
          <div className="json-array">
            {value.map((item, index) => (
              <div key={index} className="json-array-item">
                {typeof item === 'object' && item !== null ?
                  <div className="nested-object">
                    <div className="item-header">Item {index + 1}</div>
                    <JsonTable data={item} />
                  </div> :
                  renderValue(item)
                }
              </div>
            ))}
          </div>
        );
      }
      // Safe recursive rendering for other objects
      try {
        return <JsonTable data={value} />;
      } catch (error) {
        console.error('Error rendering object:', error);
        return <pre>{JSON.stringify(value, null, 2)}</pre>;
      }
    }
    // Convert primitive values to string
    return String(value);
  };

  // Function to sort keys to ensure specific fields appear first
  const sortKeys = (entries, priorityField) => {
    // If the priority field exists, move it to the front
    if (entries.some(([key]) => key === priorityField)) {
      return [
        ...entries.filter(([key]) => key === priorityField),
        ...entries.filter(([key]) => key !== priorityField)
      ];
    }
    return entries;
  };

  // Get entries and sort them if needed
  const entries = Object.entries(data);

  // For the response tab, prioritize pdf_processing_note
  // For the validation tab, prioritize summary
  const sortedEntries = sortKeys(entries, 'pdf_processing_note');
  const sortedEntriesWithSummary = sortKeys(sortedEntries, 'summary');

  return (
    <div className="json-table-container">
      <table className="json-table">
        <tbody>
          {sortedEntriesWithSummary.map(([key, value], index) => (
            <tr key={index}>
              <td style={{ width: '25%' }} className="json-key">{key.replace(/_/g, ' ')}</td>
              <td style={{ width: '75%' }} className="json-value">{renderValue(value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JsonTable;
